<template>
  <div v-if="googleClientId" ref="parentDiv" class="parent-container">
    <GoogleSignInButton
      class="google-login"
      :width="buttonWidth"
      size="large"
      text="continue_with"
      logo-alignment="center"
      @success="handleLoginSuccess"
      @error="handleLoginError"
    />
  </div>
</template>

<script setup lang="ts">
//@ts-nocheck
const { setToken, profile, checkGoogleToken } = useAuth();
import { toast } from "vue3-toastify";
import {
  GoogleSignInButton,
  type CredentialResponse,
} from "vue3-google-signin";
const googleClientId = useRuntimeConfig().public.googleClientId;
const handleLoginSuccess = async (response: CredentialResponse) => {
  const { credential } = response;
  await getGoogleToken(credential);
};

async function getGoogleToken(token) {
  try {
    const res = await checkGoogleToken({
      token: token,
    });
    if (res?.data) {
      await setToken(res?.data);
      toast.success("You've successfully logged in!");
      await profile();
      await location.reload();
    }
  } catch (error) {
    console.error("Error fetching token:", error);
  }
}

const handleLoginError = () => {
  console.error("Login failed");
};
const isDesktop = ref(false);
const buttonWidth = ref(320);
const parentDiv = ref(null);
const handleResize = () => {
  isDesktop.value = window.innerWidth >= 1024;
};
onMounted(() => {
  handleResize();
  updateButtonWidth();
});
const updateButtonWidth = () => {
  if (parentDiv.value) {
    buttonWidth.value =
      parentDiv.value.clientWidth || (isDesktop.value ? 400 : 320);
  }
};
const linkTarget = computed(() => {
  return isDesktop.value ? "_blank" : "_self";
});
</script>
<style scoped>
.parent-container {
  /* Ensure this has some width for demo purposes */
  width: 100%;
}
</style>
